import React from "react";
import { DateDisplay } from "../DateDisplay";
import { OperationalConfiguration } from "../../models/OperationalConfiguration";
import { ValueDisplayProps } from "../ValueDisplay";
import { GridValueDisplayList } from "../GridValueDisplayList";

interface OperationalConfigurationDetailsProps {
	operationalConfiguration: OperationalConfiguration;
}

/**
 * Display an operational configuration
 * @param props
 */
export const OperationalConfigurationDetails = (props: OperationalConfigurationDetailsProps) => {
	const data = props.operationalConfiguration;

	const detailsToDisplay: ValueDisplayProps[] = [
		{
			label: "Name",
			node: data.name,
		},
		{
			label: "Display name",
			node: data.displayName,
		},
		{
			label: "Default value",
			node: data.defaultValue,
		},
		{
			label: "Description",
			node: data.description,
		},
		{
			label: "Created on",
			node: <DateDisplay date={data.createdDate} />,
		},
		{
			label: "Created by",
			node: data.createdBy,
		},
		{
			label: "Updated on",
			node: <DateDisplay date={data.lastUpdatedDate} />,
		},
		{
			label: "Updated by",
			node: data.updatedBy,
		},
	];

	return <GridValueDisplayList displayItems={detailsToDisplay}></GridValueDisplayList>;
};
